import React from 'react';

const Notification = ({ classe, message }) => (
  <div className={`alert alert-${classe} notification-style`} role="alert" style={{ marginTop: '2rem' }}>
    {message}
  </div>
);

export default Notification;
